import { render, staticRenderFns } from "./ModalWmts.vue?vue&type=template&id=bd8eeb16"
import script from "./ModalWmts.vue?vue&type=script&lang=js"
export * from "./ModalWmts.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports